import { type GridColDef, type GridRenderCellParams } from '@mui/x-data-grid-pro';
import { deCamelize } from '../../utils/grid';
import { GridCell } from './GridCell';

interface IGridColDefExtended extends GridColDef {
    required?: boolean;
    textWrap?: boolean
  }

type TDataGridRowOptions = Omit<IGridColDefExtended, 'field'>;

export const renderBooleanCell = ({ value }: GridRenderCellParams) => (value ? 'Yes' : 'No');

export const gridBooleanCell = {
    type: 'boolean',
    editable: true,
    onClick: (event: MouseEvent) => event.stopPropagation(),
    renderCell: renderBooleanCell,
  };

  export const dataGridCol = (field: string, options?: TDataGridRowOptions): GridColDef & { minHeight: number } => {
  const headerName = deCamelize(field);
  return {
    field,
    headerName,
    description: headerName,
    minHeight: 55,
    maxWidth: 1500,
    renderCell: (props) => options?.textWrap ? props.formattedValue || props.value || '' : <GridCell text={props.formattedValue || props.value || ''} />,
    ...options,
  };
};